import React from "react";
import { useFormApi } from "../useForm";
import "./FormError.scss";
function getErrorMessage(error) {
    if (error.message)
        return error.message;
    switch (error.type) {
        case "required":
            return "This field is required.";
    }
    return "This field is not filled out correctly.";
}
/**
 * Displays errors for the specified form field (if any). Typically not used directly, but by the other form controls.
 */
function FormError({ id }) {
    const form = useFormApi();
    const error = form.getError(id);
    if (error) {
        const message = getErrorMessage(error);
        return React.createElement("p", { className: "form-error" }, message);
    }
    return null;
}
export default FormError;
